import React from 'react';
import { Heading, SectionLabel } from '../components/ui-bits';
import ContactForm from '../components/ContactForm';
import { BRAND } from '../data/mock';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

export default function Contact() {
  return (
    <main className="pt-32">
      <section className="max-w-[1240px] mx-auto px-6 md:px-10 py-16">
        <SectionLabel>Contact</SectionLabel>
        <Heading className="mt-5 font-serif max-w-3xl">Start Planning <span className="italic">Your Wedding.</span></Heading>
        <p className="mt-6 max-w-2xl text-[#4a5c60] text-lg">Tell us what you’re imagining—even if all you know today is: “We want to get married somewhere beautiful.” We’ll start from there.</p>
      </section>

      <section className="max-w-[1240px] mx-auto px-6 md:px-10 pb-24 grid lg:grid-cols-3 gap-14">
        <div className="lg:col-span-2"><ContactForm /></div>
        <aside className="space-y-10">
          <div>
            <div className="eyebrow text-[#a6894f]">Reach us</div>
            <ul className="mt-5 space-y-5 text-[#304247]">
              <li className="flex gap-4"><MapPin size={18} className="text-[#c3a66d] shrink-0 mt-1" /><span>{BRAND.address}</span></li>
              <li className="flex gap-4 items-center"><Phone size={18} className="text-[#c3a66d] shrink-0" /><a href={`tel:${BRAND.phone}`} className="link-underline">{BRAND.phone}</a></li>
              <li className="flex gap-4 items-center"><Mail size={18} className="text-[#c3a66d] shrink-0" /><a href={`mailto:${BRAND.email}`} className="link-underline">{BRAND.email}</a></li>
              <li className="flex gap-4 items-center"><Clock size={18} className="text-[#c3a66d] shrink-0" /><span>Mon – Sat · 10:00 – 19:00 IST</span></li>
            </ul>
          </div>
          <div className="border border-[#e8e0d2] p-6 bg-[#faf4ea]">
            <div className="eyebrow text-[#a6894f]">Professionals</div>
            <p className="mt-3 text-[#304247] text-sm">Interested in joining the Sunday Mirror network? Apply through our professional onboarding.</p>
            <a href="mailto:info@sundaymirror.in" className="link-underline eyebrow text-[#053e49] mt-4 inline-block">Apply to Join →</a>
          </div>
          <div className="border border-[#e8e0d2] p-6 bg-[#faf4ea]">
            <div className="eyebrow text-[#a6894f]">Venues</div>
            <p className="mt-3 text-[#304247] text-sm">Hotels, resorts and heritage properties can partner with us to host professionally managed destination weddings.</p>
            <a href="mailto:info@sundaymirror.in" className="link-underline eyebrow text-[#053e49] mt-4 inline-block">Become a Venue Partner →</a>
          </div>
        </aside>
      </section>
    </main>
  );
}
